export const TEST_CASE_EMPTY_VARIANTS = {
  NO_MODULE: 'noModule',
  NO_TEST_CASE: 'noTestCase',
  SELECT_MODULE: 'selectModule',
};

export const TEST_CASE_EMPTY_CONTENT = {
  [TEST_CASE_EMPTY_VARIANTS.NO_MODULE]: {
    title: 'Start by creating a module',
    description:
      'Test cases live inside modules — folders that help you organize by feature, flow, or team. Create your first module using the panel on the left.',
    hint: 'Click the ⋮ menu next to your project name, then "Add module".',
    buttonLabel: null,
  },
  [TEST_CASE_EMPTY_VARIANTS.NO_TEST_CASE]: {
    title: 'No test cases in this module yet',
    description: (moduleName) => {
      const moduleLabel = moduleName?.trim()
        ? `"${moduleName.trim()}"`
        : 'module';

      return `Add your first test case to ${moduleLabel}. You can also import existing cases in bulk using the Import button above.`;
    },
    buttonLabel: 'Add Test case',
  },
  [TEST_CASE_EMPTY_VARIANTS.SELECT_MODULE]: {
    title: 'Select a module to get started',
    description: 'Choose a module from the left panel to create your first test case.',
  },
};
